<template>
  <div id="base">
      <tab-bar></tab-bar>
      <router-view />
  </div>
</template>

<script>
import {api} from '../../api/api.js'
import Tabbar from '@/base/tabbar/tabbar'
export default {
  data() {
    return {
      
    }
  },
  components:{
    'tab-bar':Tabbar
  },
  mounted() {
    api.login({}).then(res=>{
      
    })
  },
}
</script>

<style>
  #base {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shop/base.vue